import { render, staticRenderFns } from "./SkinsTab.vue?vue&type=template&id=5c043908&"
import script from "./SkinsTab.vue?vue&type=script&lang=ts&"
export * from "./SkinsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports